import React from "react";
import { Grid } from "@mui/material";

/**
 * Formats a price with 3 significant figures if below $1, otherwise 2 decimal places
 * @param price - The price to format
 * @returns Formatted price string
 */
const formatPrice = (price: number): string => {
  if (price < 1 && price > 0) {
    // Use toPrecision(3) for 3 significant figures
    const formatted = price.toPrecision(3);
    // If it's in scientific notation, convert to decimal
    if (formatted.includes('e')) {
      return parseFloat(formatted).toString();
    }
    // Remove trailing zeros after decimal point
    return parseFloat(formatted).toString();
  }
  return price.toFixed(2);
};

export default function ChartMetaData(props: any) {
  const code = props.currencyConfig.code;
  return (
    <div
      className="custom-legend"
      style={{
        top: props.isMobile ? "28%" : "70%",
        fontSize: 14,
        zIndex: 10,
      }}>
      <Grid container alignItems="left" justifyContent="space-between">
        <Grid item xs={12} sm={12}>
          <Grid container>
            <Grid item xs={12}>
              {` O `}
              <span style={{ color: "red" }} translate="no">
                {formatPrice(props.candlestickData.open)}
              </span>
              {` H `}
              <span style={{ color: "red" }} translate="no">
                {formatPrice(props.candlestickData.high)}
              </span>
              {` L `}
              <span style={{ color: "red" }} translate="no">
                {formatPrice(props.candlestickData.low)}
              </span>
              {` C `}
              <span style={{ color: "red" }} translate="no">
                {formatPrice(props.candlestickData.close)}
              </span>
              {` Vol`} &#8226; {code}
              <span style={{ color: "red" }} translate="no">
                {" "}
                {props.candlestickData.volume}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
